import { render, staticRenderFns } from "./JobDeletedJob.vue?vue&type=template&id=347a0fb4&"
import script from "../../../services/admin/job/job-deleted-job.js?vue&type=script&lang=js&"
export * from "../../../services/admin/job/job-deleted-job.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports